import angular from 'angular';

import PrivilegeTemplateFormComponent from './privilege-template-form-component';

export default angular.module('privilege-template-form', []).component('privilegeTemplateForm', new PrivilegeTemplateFormComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-form/privilege-template-form-module.js